import {
  smsTemplateSchema,
  type SmsTemplate,
} from "@redotech/redo-model/sms-template";
import * as z from "zod";

export const paginateSmsTemplates = {
  name: "paginateSmsTemplates" as const,
  input: z.object({
    searchText: z.string().optional(),
    page: z.number().positive(),
    pageSize: z.number().positive(),
  }),
  output: z.object({
    data: z.array(smsTemplateSchema as z.ZodType<SmsTemplate>),
    paginationKey: z.string().optional(),
    // Add total count and pagination info for page-based pagination
    totalCount: z.number().optional(),
    currentPage: z.number().optional(),
    totalPages: z.number().optional(),
  }),
};
